<template>
  <div
    class="scroll view"
    >
    <div class="faces-list">
      <owal-header-banner  title="Tracks Training Tool"/>
      <div
        v-for="(track, index) of tracks"
        :key="track.track_uuid"
      >
        <tracks-training-tool-detection-banner
        :index="index"
        :track="track"
        @empty-track="removeTrack(index)"
        @track-verified="removeTrack(index)"
        @track-hidden="removeTrack(index)"
        />
        <div><button @click="createNewTrack(index)">+</button></div>
      </div>
      <owal-spinner-banner v-if="searching" slot="spinner" />
    </div>
    <div style="width: 200px; margin: auto;" class="faces-training-tool__footer">
      <owal-banner v-if="!searching && tracks && !tracks.length" class=".owal-banner__narrow magnet pull">
        <div class="owal-banner__text-centered"> No Results </div>
      </owal-banner>
      <owal-banner v-if="!searching && tracks.length > 0" class="owal-banner__narrow">
        <div class="owal-banner__text-centered">
          <button class="ui button" @click="loadResults">
            Load More
          </button>
        </div>
      </owal-banner>
    </div>
  </div>
</template>

<script>
import { loadTracks, addTrack } from '@/libraries/api/faces'
import { mapGetters } from 'vuex'

const OwalBanner = () => import('@/libraries/owal-ui/banners/OwalBanner')
const OwalSpinnerBanner = () => import('@/libraries/owal-ui/spinners/OwalSpinnerBanner')
const OwalHeaderBanner = () => import('@/libraries/owal-ui/banners/OwalHeaderBanner')
const TracksTrainingToolDetectionBanner = () => import('./TracksTrainingToolDetectionBanner')

export default {
  name: 'Tracks',
  components: {
    OwalHeaderBanner,
    OwalSpinnerBanner,
    TracksTrainingToolDetectionBanner,
    OwalBanner,
  },
  data () {
    return {
      tracks: [],
      searching: true,
    }
  },
  watch: {
    currentDomainUUID: function () {
      console.log('domain uuid changed')
      this.tracks = []
      this.loadResults()
    },
  },
  computed: {
    ...mapGetters({
      isAuthenticated: 'isAuthenticated',
      cameraForId: 'cameraForUUID',
      frontendFaces: 'frontendFaces',
      currentDomainUUID: 'currentDomainUUID',
    }),
    params () {
      const params = {
        domainUUID: this.currentDomainUUID,
        // TODO add filter support
      }
      return params
    },
  },
  created () {
  },
  mounted () {
    this.loadResults()
  },
  methods: {
    async loadResults ($state) {
      this.searching = true
      const since = this.tracks.length > 0 ? this.tracks.map(t => t.track_start)[this.tracks.length -1] : new Date().toISOString()
      try {
        const res = await loadTracks({ domainUUID: this.currentDomainUUID, since })
        const data = res.data
        if (!data.ok) {
          this.searching = false
          /* if ($state) {
            $state.complete()
          } */
          return console.log(data.err)
        }
        this.tracks = this.tracks.concat(data.tracks)
        console.log(this.tracks)
          // if ($state) {
          //   $state.loaded()
          // }
        this.searching = false
  // /*        this.newResults = data.new_results || 0*/
  //         this.updateRefreshToken(data.refresh_token)
  //         console.log(this.refreshToken)
      } catch (err) {
        console.log(err)
        // $state.complete()
        this.searching = false
      }
    },
    async createNewTrack(index) {
      // add to the database,
      const { data } = await addTrack(this.currentDomainUUID)
      console.log(data)
      // show new track as dropzone
      this.tracks.splice(index + 1, 0, { track_uuid: data.uuid, track_detections: [] })
    },
    removeTrack(index) {
      this.tracks.splice(index, 1)
    },
  },
}
</script>

<style scoped>

.scroll.view {
  height: 100%;
  width: 100%;
  overflow: auto;
}

@media only screen and (min-width: 768px) {
  .scroll.view {
    padding: 4rem;
    margin-bottom: 4rem;
  }
}

#header {
  display: flex;
  flex-direction: column;
  align-content: center;
}

#header #back {
  align-self: flex-start;
}

#header #title {
  margin: 0;
  font-weight: bold;
}

.faces-list {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0;
  /*width: 68.5714285714rem;*/
}

.owal-banner__narrow {
  display: flex;
  width: 200px;
  flex-grow: 0;
  flex-shrink: 0;
}
.owal-banner__text-centered {
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  font-family: 'Lato-Bold';
  padding: 0.5rem;
  margin: 0.5714285715rem auto;
  text-align: center;
}

.faces-training-tool__footer {

}

</style>
